module.exports = __webpack_public_path__ + "static/info_tile-11eafe412962ca80f0551a37ed2c8700.png";